const updateLoyaltyPreferences = loyalty => {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({
      type: 'updateLoyaltyPreferences',
      data: {
        loyalty
      }
    })
  )
}

export default {
  updateLoyaltyPreferences
}
